/*
 * File: ui-label.ts
 * File Created: 2023-12-18 11:45:26
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-11-25 09:48:43
 * Modified By: Val Liu
 * -----
 */

import { StringHelper } from "../utilities";
import {
    BaseUITag,
    EUITagRuleType,
    EUITagRuleUnion,
    EUITagTarget,
    IUITagInput,
    IUITagResult,
    UITag,
} from "./core";
import { lang } from "@root/core/i18n";

// @uiRequired - add prop `required` to form element.

@UITag.set({ default: true })
export class uiRequired extends BaseUITag {
    appliedTo: EUITagTarget[] = [EUITagTarget.FormElement];
    ruleTypes: EUITagRuleUnion[] = [EUITagRuleType.Boolean, EUITagRuleType.String];
    allowNullRule: boolean = true; /// default: get value from meta type.optional

    /// set props :description
    parse(input: IUITagInput): IUITagResult | null {
        let rule = this.parseRule(input);

        if (input.isDefault === true) {
            /// default from metadata type
            rule = !input.meta.attr.type.optional;
        } else if (rule == null) {
            rule = true;
        } else if (rule == "inherit") {
            return null;
        }

        /// normal case
        return {
            props: { required: rule },
        };
    }
}
